import React from 'react'
import PropTypes from 'prop-types'

export const Confirmation = props => {
  return (
    <React.Fragment>
      <h3>Thank you for your order!</h3>
      {props.emailSent ? (
        <p>A confirmation has been sent to: {props.email}</p>
      ) : (
        <p>
          Your order was received. If you don&apos;t receive your access codes by
          email shortly, contact support@myeducator.com.
        </p>
      )}
    </React.Fragment>
  )
}

Confirmation.propTypes = {
  email: PropTypes.string,
  emailSent: PropTypes.bool,
}
